import React from "react";
import { Card, Typography } from "antd";
import { DocumentTitle } from "../../components";
import I18n from "../../i18n";

export default function AboutUs() {
  return (
    <DocumentTitle title={I18n.general.aboutUs}>
      <Card
        style={{ margin: 32 }}
        title={
          <Typography.Title level={3}>{I18n.general.aboutUs}</Typography.Title>
        }
      >
        <Typography.Paragraph>
          وبسایت مجموعه فروش پوشاک بهارا برند Bahara Brand با اتکا به بیش از پنج
          سال حضور در مد و صنعت پوشاک پا به عرصه فروش اینترنتی نهاد. ارائه محصول
          با کیفیت و به صرفه و ارائه محصولات متنوع اصول و اهداف اولیه بهارا برند
          بوده و خواهد بود. ما به خود مفتخریم که اجناس با کیفیت و با مناسب‌ترین
          قیمت برای مشتریان عزیز درنظر می گیریم.
        </Typography.Paragraph>
        <Typography.Paragraph>
          ما همواره سعی میکنیم تا در کمترین زمان ممکن با کمترین ضریب خطا و با
          استفاده از شیوه های نوین ثبت سفارش، ارسال و بسته بندی، محصولات خریداری
          شده را به دست مشتریان عزیز رسانده و روز به روز با نوآوری در این راه
          قدم برداریم.
        </Typography.Paragraph>
        <Typography.Paragraph>
          با تیم حرفه ای مجموعه بهارا برند از ارائه بهترین خدمات لذت ببرید.
        </Typography.Paragraph>
      </Card>
    </DocumentTitle>
  );
}
